module.exports = __webpack_public_path__ + "static/media/searchIcon-final.d49c8394.svg";